<template>
    <notification-behavioral ref="notificationBase" class="notification-pricing-completed" :item="item"
                             :behaviors="behaviors"
                             @behaviorLoaded:schedule="behaviorScheduleReceived"
                             @behaviorCompleted:collateral="handleCollateralSent"
                             @behaviorCompleted:pricing="handlePricingSent"
                             @behaviorCompleted:schedule="handleScheduleSent"
    >
        <template slot="title" :item="item">
            <div class="" style="flex:1">
                <span v-if="success > 0" class="badge pricing-status-success">{{success}}</span>
                <span v-if="pending > 0" class="badge pricing-status-pending">{{pending}}</span>
                <span v-if="rejected > 0" class="badge pricing-status-rejected">{{rejected}}</span>
                {{item.customerName}} - {{item.title}} <a :href="'/partner/customer/index/id/' + item.customerId"><span class="glyphicon glyphicon-globe"></span></a>
            </div>
        </template>

        <div slot="body" class="table-flex bordered no-outline">
            <div class="" style="display:flex;justify-content:space-between;">
                <div class="text-center" style="flex:1">Quote</div>
                <div class="text-center" style="flex:0 1 25%">Base</div>
                <div class="text-center" style="flex:0 1 25%">Rate</div>
            </div>
            <div v-for="q in item.quotes" class="notification-quotes" style="display:flex;justify-content:space-between;">
                <div class="quote-title" style="flex:1">{{q.term}} Mo. {{q.product}} {{q.billMethod}}</div>
                <div class="text-right quote-base-rate" style="flex:0 1 25%">{{q.baseRate}}</div>
                <div class="text-right quote-total-rate" style="flex:0 1 25%">{{q.totalRate}}</div>
            </div>
        </div>
    </notification-behavioral>
</template>

<script>
    import NotificationBehavioral from '@/components/notifications/behaviors/Behavioral'

    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        name: 'NotificationPricingCompleted',
        data () {
            return {
                behaviors: [
                    {
                        name: 'collateral',
                        label: '',
                        description: 'Download Collateral',
                        icon: 'glyphicon-download',
                        requestAction: () => {
                            return '/partner/customer-quote/load-quote-action/quoteAction/collateral/opportunityId/' + this.item.objectId
                        },
                        requestMethod: 'post'
                    },
                    {
                        name: 'pricing',
                        label: '',
                        description: 'Refresh Pricing',
                        icon: 'glyphicon-refresh',
                        requestAction: () => {
                            return '/partner/customer-quote/load-quote-action/quoteAction/pricing/opportunityId/' + this.item.objectId
                        },
                        requestMethod: 'post'
                    },
                    {
                        name: 'schedule',
                        label: '',
                        description: 'Schedule Follow-Up',
                        icon: 'glyphicon-calendar',
                        requestAction: () => {
                            return '/partner/customer-task/load/customerid/' + this.item.customerId + '/tasktype/3'
                        },
                        requestMethod: 'post'
                    }
                ]
            }
        },
        computed: {
            success () {
                let count = 0
                for (let quote in this.item.quotes) {
                    if (Number(this.item.quotes[quote].totalRate) > 0 && Number(this.item.quotes[quote].baseRate) > 0) {
                        count++
                    }
                }
                return count
            },
            pending () {
                let count = 0
                for (let quote in this.item.quotes) {
                    if (this.item.quotes[quote].totalRate === 'Pending...' && this.item.quotes[quote].baseRate === 'Pending...') {
                        count++
                    }
                }
                return count
            },
            rejected () {
                let count = 0
                for (let quote in this.item.quotes) {
                    if (this.item.quotes[quote].totalRate === 'Rejected' && this.item.quotes[quote].baseRate === 'Rejected') {
                        count++
                    }
                }
                return count
            }
        },
        methods: {
            behaviorScheduleReceived: function (container) {
                container.querySelector('textarea').textContent = 'Pricing Reminder - '
            },
            handlePricingSent: function (data, container) {
                this.$refs.notificationBase.downloadAjaxFile(data.fileName, data.fileContents, container)
            },
            handleCollateralSent: function (data, container) {
                this.$refs.notificationBase.downloadAjaxFile(data.fileName, data.fileContents, container)
            },
            handleScheduleSent: function (data) {
                this.$refs.notificationBase.showBehaviorMessage(data.message, 'success')
            }
        },
        components: {
            NotificationBehavioral
        },
        filters: {
            formatAsCurrency: function (amount, precision) {
                if (typeof precision === 'undefined') {
                    precision = 5
                }

                return parseFloat(amount).toFixed(precision).toLocaleString()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .notification-body {
        margin: 0.5em 0;
    }

    .notification-body > div:first-child {
        border: 1px solid #000;
        border-width: 0;
    }

    .notification-body > div > div {
        border: 1px solid #000;
        border-width: 0px 1px 1px 0px;
        padding: 1%;
    }

    .notification-body > div > div:first-child {
        border-width: 0px 1px 1px 0px;
    }

    .notification-body > div > div:last-child {
        border-right: 0;
    }

    .notification-body > div:last-child > div {
        border-bottom: 0;
    }

    .notification-pricing-completed {
        min-width: 400px;
    }

</style>



// WEBPACK FOOTER //
// PricingCompleted.vue?038adafd